import React from "react";
import { motion } from "framer-motion";
import { landingAssets } from "config/landing";
import { TitleBadge } from "./TitleBadge";

export const ContactSection = () => (
  <section
    id="contact-section"
    className="flex w-full pt-16 pb-32 px-3 md:px-5 lg:px-10 lg:py-6 2xl:px-20 text-white scroll-mt-32"
  >
    <div className="flex w-full flex-col justify-between gap-4 2xl:gap-10 lg:flex-row">
      <motion.div
        className="flex-1 space-y-4 lg:space-y-6 lg:w-1/3 items-center justify-center text-center lg:items-start lg:text-start"
        initial={{ x: -80, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <TitleBadge title="Contact Us" />
        <p className="text-sm text-gray-200 lg:text-lg 2xl:text-xl font-medium">
          For detailed information and to purchase, please contact us.
        </p>
        <div className="flex flex-row gap-2 items-center text-sm lg:text-lg 2xl:text-xl justify-center text-center lg:justify-start lg:text-start">
          <p className="text-gray-200 font-medium">Email : </p>
          <a
            href="mailto:info@geniustracker.com"
            className="font-bold text-white hover:text-primary transition"
          >
            info@geniustracker.com
          </a>
        </div>
      </motion.div>
      <motion.div
        className="flex-1 border border-border bg-gray-700 px-5 py-6 lg:py-9 lg:px-8 lg:w-2/3"
        initial={{ x: 80, opacity: 0, y: 16 }}
        whileInView={{ x: 0, opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.75, ease: "easeOut" }}
        whileHover={{ scale: 1.01, boxShadow: "0 24px 60px rgba(0,0,0,0.55)" }}
      >
        <div className="mb-7 flex items-center gap-5">
          <img
            src={landingAssets.logos.simple.src}
            alt={landingAssets.logos.simple.alt ?? landingAssets.metadata.pageTitle}
            className="h-10 w-11"
            loading="lazy"
          />
          <p className="text-base lg:text-xl font-bold">Contact Form</p>
        </div>
        <form className="space-y-4">
          <input
            type="text"
            className="w-full rounded-md border border-border bg-gray-800 px-6 py-2 text-sm lg:text-base text-white placeholder:text-gray-200/40 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/40"
            placeholder="Name surname*"
          />
          <input
            type="email"
            className="w-full rounded-md border border-border bg-gray-800 px-6 py-2 text-sm lg:text-base text-white placeholder:text-gray-200/40 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/40"
            placeholder="Email*"
          />
          <input
            type="tel"
            className="w-full rounded-md border border-border bg-gray-800 px-6 py-2 text-sm lg:text-base text-white placeholder:text-gray-200/40 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/40"
            placeholder="Phone"
          />
          <textarea
            rows={4}
            className="w-full rounded-md border border-border bg-gray-800 px-6 py-2 text-sm lg:text-base text-white placeholder:text-gray-200/40 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/40"
            placeholder="Your Message"
          />
          <motion.button
            type="button"
            className="ml-auto flex w-full items-center justify-center rounded-md bg-primary px-6 py-4 text-sm lg:text-base font-extrabold text-white transition hover:bg-primary-hover lg:max-w-52"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.97 }}
          >
            Send
          </motion.button>
        </form>
      </motion.div>
    </div>
  </section>
);
